<template>
    <el-drawer
        title="编辑收费账号"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="40%"
        :before-close="close">
        <div class="panel form">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="班级">
                    <el-select v-model="form.classId" filterable placeholder="班级">
                        <el-option
                            v-for="item in classOptin"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学生">
                    <el-input v-model="studentName"  disabled></el-input>
                </el-form-item>
                <el-form-item label="转换学生">
                    <el-select v-model="studentNames[0]" remote filterable :disabled="studentIds.length > 0"  placeholder="请输入学生姓名"  :remote-method="userSearch" @change="selectChanged">
                        <el-option
                            v-for="item in students"
                            :key="item.id"
                            :label="item.name"
                            :value="{id:item.id,name:item.name}">
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.sn }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="剩余天数">
                    <el-input-number v-model="form.chargeCount"  :min="1"  label="" :disabled="form.id > 0" ></el-input-number>
                </el-form-item>

            </el-form>
        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">取 消</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "item",
            "onClose",
        ],
        data() {
            return {
                show: false,
                form: {...this.item
                },
                userFrom:{isStudent: true, enable: true,},
                classOptin:{},
                classFrom:{useType:2},
                studentIds:[],
                studentNames:[],
                studentName:"",
                students: {},
                needRefreshParent: false,
                selfInfo:{},
            }

        },


        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            sub() {
                if(this.form.id > 0){
                    this.$ajaxPost("/lessonCharge/save", {
                        lessonCharge:this.form
                    }, (data) => {
                        this.$emit("submit", data.result);
                        this.needRefreshParent = true;
                        this.$showSuccess("保存成功");
                    })
                    return;
                }
                this.$ajaxPost("/lessonCharge/save", {
                    lessonCharge: {chargeCount:this.form.chargeCount,classId:this.form.classId},studentIds:this.studentIds.join(",")
                }, (data) => {
                    this.$emit("submit", data.result);
                    this.needRefreshParent = true;
                    this.$showSuccess("保存成功");
                })
                return false;
            },
            selectChanged(params) {
                this.studentIds = [];
                this.studentNames = [];
                if(params != null){
                    this.studentIds.push(params.id);
                    this.studentNames.push(params.name);
                }
                if(this.form.id>0){
                     this.form.studentId = params.id;
                }
            },
            loadClassOptin() {
                this.$ajaxPost("/class/list",{form:this.classFrom}, (data) => {
                    this.classOptin = data.result;
                })
            },
            userSearch(query) {
                if(this.form.id > 0){
                    this.studentNames = [];
                }
                this.form.keywords = query;
                this.$ajaxPost("/user/list", {
                    form: {isStudent:true,classId:"",keywords:query}
                }, (data) => {
                    this.students = data.result;
                })
            },
            loadInstitution(){
                this.$ajaxGet("/institution/getInstitutionOne", (data) => {
                    this.form.leftChargeCount = data.result.leftChargeCount;
                })
            },
            loadStudent() {
                this.$ajaxGet("/user/getUserOne/" + this.item.studentId, (data) => {
                    this.studentName = data.result.name;
                    if(this.form.id > 0){
                        this.studentId = data.result.id;
                    }
                })
                this.form.studentId = "";
            },
        },
        mounted() {
            this.show = true;
        },
        created() {
            //this.loadstudents();
            this.loadClassOptin();
            this.loadInstitution();
            if(this.item.id){
                this.loadStudent();
            }
        }


    }
</script>

